// Config
export const APP_NAME = import.meta.env.VITE_APP_NAME || 'HRX';
export const APP_API_URL = import.meta.env.VITE_APP_API + '/api';
export const AUTH_API_URL = import.meta.env.VITE_AUTH_API + '/api';
export const NODE_ENV = import.meta.env.VITE_NODE_ENV;
